/**
 * @file: CreateLeadHeaderButton.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The nav-header "+" affordance on the lead list: a white circle with a brand
 * plus icon that opens the manual create-lead form (`_createLead`).
 */

import { LeadsNavParams } from '@euler/app/flows/leads';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { Plus } from 'lucide-react-native';
import { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

export const CreateLeadHeaderButton = memo(() => {
  const { rpx } = useResponsiveContext();
  const navigation = useNavigation<StackNavigationProp<LeadsNavParams>>();
  const onPress = useCallback(() => {
    navigation.navigate('_createLead', {});
  }, [navigation]);
  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={onPress}
      style={{
        width: rpx(36),
        height: rpx(36),
        borderRadius: rpx(18),
        marginRight: rpx(12),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: LD.surface,
        shadowColor: '#1B2A44',
        shadowOpacity: 0.08,
        shadowRadius: rpx(6),
        shadowOffset: { width: 0, height: rpx(2) },
        elevation: 2,
      }}
    >
      <Plus size={rpx(20)} color={LD.brand} />
    </TouchableOpacity>
  );
});
